import React, { useState, useEffect } from 'react';
import { Container, Card } from 'react-bootstrap';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import Loading from '../../components/Loading';
import Breadcrumbs from '../../components/Breadcrumbs';
import Forms from '../../components/Forms';
import { useNotification } from '../../components/Notification/NotificationContext';
import axios from '../../services/axios';
import ErrorProcessor from '../../components/ErrorProcessor';

export default function Product() {
  const [isLoading, setIsLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState({});
  const notification = useNotification();
  const navigate = useNavigate();
  const { id } = useParams();
  const isNewProduct = !id;
  const [formValues, setFormValues] = useState({ name: '' });

  useEffect(() => {
    if (!id) return;
    
    const getProductData = async () => {
      try {
        setIsLoading(true);
        const { data } = await axios.get(`/products/${id}`);
        setFormValues({ name: data.name || '' });
      } catch (err) {
        setApiErrors(err);
      } finally {
        setIsLoading(false);
      }
    };

    getProductData();
  }, [id]);

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required('Nome obrigatório.')
      .min(3, 'O nome deve ter pelo menos 3 caracteres.')
      .max(255, 'O nome deve ter no máximo 255 caracteres.')
  });

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);
      
      if (isNewProduct) {
        await axios.post('/products', values);
        notification('Produto cadastrado com sucesso', 'success');
      } else {
        await axios.put(`/products/${id}`, values);
        notification('Produto atualizado com sucesso', 'success');
      }
      
      navigate('/product');
    } catch (err) {
      setApiErrors(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues(prev => ({ ...prev, [name]: value }));
  };

  const actionText = isNewProduct ? 'Cadastrar' : 'Atualizar';
  const pageTitle = `${actionText} Produto`;

  return (
    <Container fluid className="px-lg-4 px-xl-5">
      <Loading isLoading={isLoading} />
      <Breadcrumbs title={pageTitle} pages={[{ link: '/product', name: 'Produto' }]} />
      <Card className="mb-5">
        <Card.Header>
          <h4 className="card-heading">{pageTitle}{!isNewProduct && `: ${formValues.name}`}</h4>
        </Card.Header>
        <Card.Body>
          <ErrorProcessor error={apiErrors} />
          <Forms
            initialValues={formValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            onChange={handleChange}
            fields={[
              {
                name: 'name',
                id: 'name',
                label: 'Nome',
                type: 'text',
                colSize: 12,
              }
            ]}
            btnSubmit={{
              variant: 'primary',
              type: 'submit',
              text: actionText,
            }}
            errors={apiErrors}
          />
        </Card.Body>
      </Card>
    </Container>
  );
}